import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['products'] });

const fetchOrganizationsProduct = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizationProduct: builder.query({
      query: ({ opk, ordering, page, psize }) => ({
        url: `community/organizations/${opk}/products/`,
        method: 'GET',
        params: {
          ordering,
          page,
          psize,
        },
      }),
      providesTags: ['products'],
    }),
    createOrganizationProduct: builder.mutation({
      query: ({ payload, opk }) => ({
        url: `community/organizations/${opk}/products/`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['products'],
    }),
    destroyOrganizationProduct: builder.mutation({
      query: ({ opk, ean }) => ({
        url: `community/organizations/${opk}/products/${ean}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['products'],
    }),
    getOneOrganizationProduct: builder.query({
      query: ({ opk, ean }) => ({
        url: `community/organizations/${opk}/products/${ean}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      providesTags: ['products'],
    }),
    editOneOrganizationProduct: builder.mutation({
      query: ({ opk, ean, payload }) => ({
        url: `community/organizations/${opk}/products/${ean}`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['products'],
    }),
    patchOneOrganizationProduct: builder.mutation({
      query: ({ opk, ean, payload }) => ({
        url: `community/organizations/${opk}/products/${ean}`,
        method: 'PATCH',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['products'],
    }),
    getProductBrand: builder.query({
      query: ({ opk, ean }) => ({
        url: `/community/organizations/${opk}/products/${ean}/brands/`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      providesTags: ['products'],
    }),
    addProductBrand: builder.mutation({
      query: ({ opk, ean, payload }) => ({
        url: `/community/organizations/${opk}/products/${ean}/brands/`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['products'],
    }),
    destroyProductBrand: builder.mutation({
      query: ({ opk, ean, id }) => ({
        url: `/community/organizations/${opk}/products/${ean}/brands/${id}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['products'],
    }),
  }),
});

export const {
  useDestroyProductBrandMutation,
  useAddProductBrandMutation,
  useGetProductBrandQuery,
  useCreateOrganizationProductMutation,
  useDestroyOrganizationProductMutation,
  useGetOrganizationProductQuery,
  useGetOneOrganizationProductQuery,
  useEditOneOrganizationProductMutation,
  usePatchOneOrganizationProductMutation,
} = fetchOrganizationsProduct;

export default fetchOrganizationsProduct;
